import { Recipient } from '@bonusly/recipient-entities';

export enum GiveBoxEvent {
	Created = 'bonus-created',
	Deleted = 'bonus-deleted',
	Open = 'init-give-recognition',
}

export enum AmplitudeEvent {
	MeaningfulMeterTips = 'Click Expand Meaningful Meter Tips',
}

// Type definition for GiveBoxEvent.Open event data
export interface GiveBoxOpenEventData {
	recipient?: Recipient;
	text?: string;
	amount?: number;
	hashtags?: string[];
}
